export enum LiveStatus {
  CREATED = 'CREATED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  DELETED = 'DELETED'
}

export type LiveProps = {
  code: string
  link: string
  reportLink: string
  startAt: number
  endAt?: number
  status: LiveStatus
  thumbnail: string
  watchCount: number
  enableVodPlayback?: boolean
  title?: string
  description?: string
  managementLink?: string
}
